import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import { version } from "../../../package.json";

export default function EnvVersionFooter() {
  return (
    <Container fluid style={{ position: "sticky", top: "100vh" }} className="w-100">
      <Row className="m-0 p-0">
        <Col className="text-center text-muted">
          <small>v{version}</small>
        </Col>
      </Row>
    </Container>
  );
}
